import { fetch } from '@ixigo/shell/fetch';

import type { CvpResponse } from '../types';

/**
 * GET the per-user CBCC landing state (eligible / ineligible / onboarding /
 * approved / resume). Drives the bottom CTA + which screen sections render.
 *
 * Invoked from the /travel-credit-card route loader (server-side on first
 * paint, and again on the client when `router.invalidate()` re-runs the loader
 * after login). The shell `fetch` injects the `at` Bearer token from cookies on
 * both server and client, so the same call is correctly authenticated either
 * way.
 */
export function fetchCvp(): Promise<CvpResponse> {
	return fetch.get('fintech/v1/cbcc/cvp').json();
}
